import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPorkManureStorage, getFootprintingPorkManureStorageAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PORK_MANURE_STORAGE } from "consts";

export const useGetFootprintingPorkManureStorage = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PORK_MANURE_STORAGE, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingPorkManureStorageAdmin(primaryDataId ?? "") : getFootprintingPorkManureStorage(primaryDataId ?? "")),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
